<template>
  <div class="fund-nav-bar" :class="[themeClass, `fund-nav-bar--${variant}`]">
    <div class="fund-nav-bar__inner">
      <div
        class="fund-nav-bar__left"
        :class="{ 'is-empty': !showBack }"
        @click="handleBack"
      >
        <van-icon v-if="showBack" name="arrow-left" class="fund-nav-bar__back" />
      </div>
      <p class="fund-nav-bar__title">{{ displayTitle }}</p>
      <div v-if="variant === 'list'" class="fund-nav-bar__actions">
        <button
          v-if="showActionIcons"
          type="button"
          class="fund-nav-bar__action-btn"
          aria-label="search"
          @click="$emit('search')"
        >
          <van-icon name="search" class="fund-nav-bar__action-icon" />
        </button>
        <button
          v-if="showActionIcons"
          type="button"
          class="fund-nav-bar__action-btn"
          aria-label="message"
          @click="$emit('message')"
        >
          <van-icon name="envelop-o" class="fund-nav-bar__action-icon" />
        </button>
        <button
          v-if="showLogoutButton"
          type="button"
          class="fund-nav-bar__logout"
          @click="handleLogout"
        >
          {{ $t("openAccount.t000136") }}
        </button>
      </div>
      <div
        v-else-if="variant === 'default'"
        class="fund-nav-bar__right-spacer"
        aria-hidden="true"
      />
    </div>
  </div>
</template>

<script>
import { Icon, Dialog } from "vant";
import { getBrowser } from "@/utils/browser";

const browser = getBrowser();

export default {
  name: "FundNavBar",
  components: {
    [Icon.name]: Icon
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    showBack: {
      type: Boolean,
      default: true
    },
    variant: {
      type: String,
      default: "default",
      validator: value => ["default", "list"].includes(value)
    }
  },
  computed: {
    themeClass() {
      return this.variant === "list" ? "" : this.$store.getters["common/bgColor"];
    },
    displayTitle() {
      return this.title || this.$route.meta.title || "";
    },
    showActionIcons() {
      return this.variant === "list" && browser.isApp;
    },
    showLogoutButton() {
      return this.variant === "list" && !browser.isApp;
    }
  },
  methods: {
    handleBack() {
      if (!this.showBack) {
        return;
      }
      if (this.$route.meta.backPath) {
        this.$router.push(this.$route.meta.backPath);
      } else {
        this.$router.go(-1);
      }
    },
    handleLogout() {
      const bgColor = this.$store.getters["common/bgColor"];
      Dialog.confirm({
        title: this.$t("openAccount.t000055"),
        message: this.$t("openAccount.t000135"),
        confirmButtonText: this.$t("openAccount.t000136"),
        className: bgColor === "black-theme" ? "black-theme-dialog" : ""
      })
        .then(() => {
          localStorage.removeItem("userInfo");
          sessionStorage.removeItem("userInfo");
          sessionStorage.removeItem("token");
          this.$router.push({
            path: "/open-account/login"
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped lang="less">
.fund-nav-bar {
  box-sizing: border-box;

  &--default {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    height: 100px;
    background: #fff;

    .fund-nav-bar__back,
    .fund-nav-bar__title {
      color: #17161c;
    }

    .fund-nav-bar__title {
      text-align: center;
    }

    &.black-theme {
      background: #1b1c24;

      .fund-nav-bar__back,
      .fund-nav-bar__title {
        color: #fff;
      }
    }
  }

  &--list {
    position: absolute;
    top: 50px;
    left: 0;
    right: 0;
    z-index: 2;
    height: 100px;
    background: transparent;

    .fund-nav-bar__back,
    .fund-nav-bar__title {
      color: #fff;
    }

    .fund-nav-bar__title {
      flex: 0 1 auto;
      text-align: left;
      padding-left: 0;
    }

    .fund-nav-bar__left {
      width: auto;
      min-width: 64px;

      &.is-empty {
        display: none;
      }
    }

    .fund-nav-bar__inner {
      justify-content: flex-start;
      gap: 8px;
    }

    .fund-nav-bar__actions {
      margin-left: auto;
    }

    .fund-nav-bar__logout {
      color: #fff;
    }
  }

  &__inner {
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 24px;
  }

  &__left {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
  }

  &__back {
    font-size: 40px;
  }

  &__title {
    flex: 1;
    min-width: 0;
    margin: 0;
    padding: 0 16px;
    font-size: 34px;
    font-weight: 500;
    line-height: 48px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__actions {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__action-btn {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
  }

  &__action-icon {
    font-size: 40px;
    color: #fff;
  }

  &__logout {
    flex-shrink: 0;
    padding: 0;
    border: none;
    background: transparent;
    font-size: 28px;
    line-height: 40px;
    cursor: pointer;
  }

  &__right-spacer {
    flex-shrink: 0;
    width: 64px;
    height: 64px;
  }
}
</style>
